
const bisForm = document.querySelector('.js-bis-form');

if(bisForm) {
    bisForm.addEventListener('submit', async e => {
        e.preventDefault();
        const email = bisForm.querySelector('input[name="email"]');
        const variantId = bisForm.querySelector('.js-product-variant');

        const options = {
          method: 'POST',
          headers: {
            accept: 'application/json',
            revision: '2024-07-15',
            'content-type': 'application/json'
          },
          body: JSON.stringify({
            data: {
              type: 'back-in-stock-subscription',
              attributes: {
                profile: {
                  data: {
                      type: 'profile',
                      attributes: {
                          email: email.value
                      }
                  },
                },
                channels: ['EMAIL']
              },
              relationships: {
                variant: {
                  data: {
                    type: 'catalog-variant',
                    id: `$shopify:::$default:::${variantId.value}`
                  }
                }
              }
            }
          })
        };

        fetch("https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=Y5BKAc", options)
        .then(() => {
            email.value = '';
            email.parentElement.parentElement.style.display = 'none';
            bisForm.querySelector('.js-bis-success').classList.remove('d-none');
        }).catch((error) => {
            console.log(error)
        });
    });
}
